import DocsList, { DocumentoBeneficiarioProps } from './DocsList';

export type { DocumentoBeneficiarioProps };

export default DocsList;
